import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import Test from "./Test";
import Video from "./Video";
import Presentation from "./Presentation";

import CourseSummary from "./CourseSummary";
import Documents from "./Documents";
import CompletedCourse from "./CompletedCourse";

const Course = (props) => {
  const { course } = props;

  const [currentSectionId, setCurrentSectionId] = useState(
    course.current_step.current_section_id,
  );
  const [currentLessonId, setCurrentLessonId] = useState(
    course.current_step.current_lesson_id,
  );
  const [showNotVerifiedModal, setShowNotVerifiedModal] = useState(false);

  const [currentSection, setCurrentSection] = useState(
    course.sections.find((section) => section.id === currentSectionId) ||
      course.sections[0],
  );
  const [currentLesson, setCurrentLesson] = useState(
    currentSection.lessons.find((lesson) => lesson.id === currentLessonId) ||
      currentSection.lessons[0],
  );

  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const newCurrentSection =
      course.sections.find((section) => section.id === currentSectionId) ||
      course.sections[0];
    setCurrentSection(newCurrentSection);

    setCurrentLesson(
      newCurrentSection.lessons.find(
        (lesson) => lesson.id === currentLessonId,
      ) || currentSection.lessons[0],
    );
  }, [currentSectionId, currentLessonId]);

  const CurrentLessonComponent = () => {
    const isLastLesson = () => {
      const lastSection =
        course.sections[course.sections.length - 1] || currentSection;
      const lastLesson =
        lastSection.lessons[lastSection.lessons.length - 1] || currentLesson;

      return lastLesson.id === currentLesson.id;
    };

    const validateCurrentLesson = async (params) => {
      return await fetch("/client/courses/" + course.id + "/verify_lesson", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          course_id: course.id,
          section_id: currentSection.id,
          lesson_id: currentLesson.id,
          ...params,
        }),
      });
    };

    const handleLessonCompletion = async (params) => {
      const response = await validateCurrentLesson(params);

      if (response.ok) {
        const data = await response.json();

        console.log(data);

        switch (data.status) {
          case "lesson_verified":
            setCurrentSectionId(data.next_section_id);
            setCurrentLessonId(data.next_lesson_id);
            break;
          case "course_completed":
            setCompleted(true);
            break;
          case "lesson_not_verified":
            setCurrentSectionId(data.next_section_id);
            setCurrentLessonId(data.next_lesson_id);
            setShowNotVerifiedModal(true);
            break;
          default:
            console.log("Nieznany status");
        }
      } else {
        console.log("error");
      }
    };

    switch (currentLesson.lesson_type) {
      case "test":
        return (
          <Test
            lesson={currentLesson}
            handleLessonCompletion={handleLessonCompletion}
            isLastLesson={isLastLesson()}
          />
        );
      case "video":
        return (
          <Video
            lesson={currentLesson}
            courseId={course.id}
            handleLessonCompletion={handleLessonCompletion}
            isLastLesson={isLastLesson()}
          />
        );
      case "presentation":
        return (
          <Presentation
            lesson={currentLesson}
            courseId={course.id}
            handleLessonCompletion={handleLessonCompletion}
            isLastLesson={isLastLesson()}
          />
        );
      default:
        return <div>Unsupported lesson type</div>;
    }
  };

  return (
    <>
      {completed ? (
        <CompletedCourse course={course} />
      ) : (
        <div className="flex flex-col lg:p-6 gap-6">
          <div className="flex flex-col gap-6 lg:flex-row">
            <div className="w-full max-w-5xl mt-10">
              <CurrentLessonComponent />
            </div>
            <CourseSummary
              sections={course.sections}
              currentSection={currentSection}
              currentLesson={currentLesson}
            />
          </div>

          {/* Full-width table under the course content, desktop and mobile alike.
              Hidden during tests so the learner cannot open the source material mid-test. */}
          {currentLesson.lesson_type !== "test" && (
            <div className="w-full max-w-5xl mt-4 lg:mt-0">
              <Documents documents={course.documents} />
            </div>
          )}

          {showNotVerifiedModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white p-6 shadow-lg max-w-xl w-full mx-4 flex flex-col">
                <h3 className="text-lg font-semibold mb-4 text-center">
                  Wynik testu negatywny
                </h3>
                <span className="mb-4 text-center">
                  W celu powtórzenia testu należy ponownie przejść całą sekcję
                </span>
                <button
                  onClick={() => setShowNotVerifiedModal(false)}
                  className="
                    w-full
                    py-2 px-6 bg-black text-white text-md
                    hover:bg-primaryYellow
                    enabled:cursor-pointer
                    transition-colors
                  "
                >
                  Zamknij
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

Course.propTypes = {
  course: PropTypes.object,
};

export default Course;
